import React from 'react';
import clsx from 'clsx';

interface TabButtonProps {
    tab: { key: string; label: string; count: number; icon: React.ElementType };
    activeTab: string;
    onClick: (key: string) => void;
}

const TabButton: React.FC<TabButtonProps> = ({ tab, activeTab, onClick }) => (
    <button
        onClick={() => onClick(tab.key)}
        className={clsx(
            'flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors',
            activeTab === tab.key ? 'bg-primary-500 text-white shadow' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
        )}
    >
        <tab.icon size={16} />
        {tab.label}
        <span className={clsx('px-1.5 py-0.5 rounded-full text-xs', activeTab === tab.key ? 'bg-white/20' : 'bg-slate-200 dark:bg-slate-600')}>
            {tab.count}
        </span>
    </button>
);

export default TabButton;
